<template>
  <List class="navlist">
    <h3 class="navlist__title">{{ title }}</h3>
    <li v-for="(data, index) in list" :key="index" class="navlist__item">
      <a
        target="_blank"
        :href="`${data.path}`"
        class="navlist__link"
        v-if="data.path"
      >
        {{ data.title }}
      </a>
      <span v-else class="navlist__link">
        {{ data.title }}
      </span>
    </li>
  </List>
</template>

<script>
import List from "@/components/ui/objects/List";

export default {
  components: { List },
  props: {
    title: {
      type: String,
      default: ""
    },
    list: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.navlist {
  border: 1px solid variables.$border-color;
  border-radius: 5px;
  &__title {
    text-align: center;
    border-bottom: 1px solid variables.$border-color;
    margin: 0;
    padding: 0.5em 1em;
  }
  &__link {
    display: block;
    padding: 3px 1em;
    font-size: 90%;
    letter-spacing: 0;
  }
  &__item {
    &:first-of-type {
      .navlist__link {
        padding-top: 10px;
      }
    }
    &:last-of-type {
      .navlist__link {
        padding-bottom: 10px;
      }
    }
  }
}
</style>
